// extracted by mini-css-extract-plugin
export default {"error":"error_error__Al0ct","error_title":"error_error_title__R3bfP","Shimiring":"error_Shimiring__7RcKl"};